import React from 'react'
import styles from 'components/Contractor/ContractorOrderStatus/ContractorOrderStatus.module.css'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { ReactComponent as UpIcon } from 'assets/icons/up.svg'
import { ReactComponent as DetailsIcon } from 'assets/icons/loupe.svg'
import { Tooltip } from '@material-ui/core'
import { AdditionalDetailsCollapse } from './AdditionalDetailsCollapse'
import { DateTimeWithZoneCell } from 'components/Shared/DateTimeWithZoneCell/DateTimeWithZoneCell'

export function StatusItem ({ status }) {

  const { t } = useTranslation()

  const CancellationStatusLabel = ({ cancellationCause, children }) => {
    return cancellationCause ? <Tooltip title={cancellationCause} arrow placement="top">
      <div>
        {children}
        <DetailsIcon width={32} height={32}/>
      </div>
    </Tooltip> : children
  }

  const formatAdditionalDetails = (deliveryPointCargo) => {
    const { quantity, weight, wrappingType, responsiblePerson, signed } = deliveryPointCargo
    return <div className={styles.additionalDetails}>
      {quantity && weight && wrappingType &&
      <p>{quantity} x {t(`contractorView.statusBar.wrappingTypes.${wrappingType}`)} @ {weight} kgs</p>}
      {responsiblePerson &&
      <p>{t('contractorView.statusBar.additionalDetails.responsiblePerson', { responsiblePerson })}</p>}
      {signed &&
      <p>{t('contractorView.statusBar.additionalDetails.signed', { signed })}</p>}
    </div>
  }

  const mapItemToStatusLabel = (item) => {
    const { deliveryPointLocation, intermediatePointNumber, deliveryPointCargo } = item
    switch (item.type) {
      case 'CONFIRMATION': {
        return t('contractorView.statusBar.confirmed')
      }
      case 'LOADED': {
        const title = t('contractorView.statusBar.loaded', { deliveryPointLocation })
        return item.status === 'TO_DO' || !deliveryPointCargo ? title
          : <AdditionalDetailsCollapse title={title}>
            {formatAdditionalDetails(deliveryPointCargo)}
          </AdditionalDetailsCollapse>
      }
      case 'ON_LOADING': {
        return t('contractorView.statusBar.onLoading', { deliveryPointLocation })
      }
      case 'UNLOADED': {
        const title = t('contractorView.statusBar.unloaded', { deliveryPointLocation })
        return item.status === 'TO_DO' || !deliveryPointCargo ? title
          : <AdditionalDetailsCollapse title={title}>
            {formatAdditionalDetails(deliveryPointCargo)}
          </AdditionalDetailsCollapse>
      }
      case 'ON_UNLOADING': {
        return t('contractorView.statusBar.onUnloading', { deliveryPointLocation })
      }
      case 'ON_FERRY_PASSAGE':
        return t('contractorView.statusBar.onFerryPassage', { intermediatePointNumber })
      case 'FERRY_PASSAGE_COMPLETED':
        return t('contractorView.statusBar.ferryPassageCompleted', { intermediatePointNumber })
      case 'ON_CUSTOMS_CONTROL':
        return t('contractorView.statusBar.onCustomsControl', { intermediatePointNumber })
      case 'CUSTOMS_CONTROL_COMPLETED':
        return t('contractorView.statusBar.customsControlCompleted', { intermediatePointNumber })
      case 'ON_CUSTOM_INTERMEDIATE_POINT':
        return t('contractorView.statusBar.onCustomIntermediatePoint', { intermediatePointNumber })
      case 'CUSTOM_INTERMEDIATE_POINT_COMPLETED':
        return t('contractorView.statusBar.customIntermediatePointCompleted', { intermediatePointNumber })
      case 'IN_TRANSIT': {
        const distanceSuffix = item.distanceKm ? `${t('contractorView.statusBar.distanceFirstPart', { distance: item.distanceKm })} ` : ''
        return `${t('contractorView.statusBar.inTransit')}${distanceSuffix}`
      }
      case 'CANCELLATION': {
        return (
          <CancellationStatusLabel cancellationCause={item.cancellationCause}>
            {t('contractorView.statusBar.cancellation')}
          </CancellationStatusLabel>
        )
      }
      default: {
        return ''
      }
    }
  }

  const mapStatusBarItemToClassName = (param) => {
    switch (param.status) {
      case 'LAST_COMPLETED': {
        return styles.bubbleDone
      }
      case 'DONE': {
        return styles.bubbleDone
      }
      case 'TO_DO': {
        return styles.bubbleToDo
      }
      default: {
        return ''
      }
    }
  }

  function inTransitElement () {
    switch (status.status) {
      case 'LAST_COMPLETED': {
        return <div className={styles.completedArrowUp}><UpIcon className={styles.completedUpIcon} width={24}
                                                                height={24}/></div>
      }
      case 'DONE': {
        return <div className={styles.arrowUp}><UpIcon width={18} height={18}/></div>
      }
      case 'TO_DO': {
        return <div className={styles.arrowUp}><UpIcon className={styles.inactiveIcon} width={18} height={18}/></div>
      }
      default: {
        return ''
      }
    }

  }

  function getStatusIcon () {
    return <div className={mapStatusBarItemToClassName(status)}>
      <div className={styles.joiningLine}/>
      {status.status === 'LAST_COMPLETED' && <div className={styles.joiningLine}/>}
      {status.type === 'IN_TRANSIT' && inTransitElement()}
    </div>

  }

  return (
    <div className={styles.rowWrapper}>
      {getStatusIcon()}
      <div className={styles.action}>
        {status.dateTime &&
        <>
          <div className={styles.actionCell}>
            {moment(status.dateTime).format('DD.MM.YYYY')}
          </div>
          <DateTimeWithZoneCell dateTime={status.dateTime}
                                timeZone={status.timeZone}
                                className={styles.actionCell}/>
        </>
        }
        <div className={styles.actionTypeCell}>
          {mapItemToStatusLabel(status)}
        </div>
      </div>
    </div>
  )
}
